<template>
  <v-overlay 
    :contained="props.contained" 
    :model-value="modelValue" 
    :class="['loader-overlay d-flex flex-column align-center justify-center', 
            {'full-screen': !props.contained}]"
    scrim="white" 
    :opacity="0.7" 
    persistent 
    z-index="9999">
    <div class="d-flex flex-column align-center">
      <img v-if="!props.generic" :src="require('@/ai_studio/assets/rubeus-loader.gif')" width="61.73" height="61.73" />
      <v-progress-circular v-else :size="props.size" color="primary-60" indeterminate></v-progress-circular>
      <span v-if="text" class="text-loader mt-4 text-primary-60 text-bold" v-html="text"></span>
    </div>
  </v-overlay>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  contained: { type: Boolean, default: false },
  generic: { type: Boolean, default: false },
  size: {type: String, default: 'default'},
  text: {type: String, default: ''}
});
</script>

<style scoped>
.loader-overlay {
  pointer-events: all;
}

.full-screen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

.text-loader {
  font-size: 16px;
}
</style>